import React, { useState } from 'react';

import LOYALBUDS from "../media/images/loyalbuds_white.png";
import { FaAppStore, FaDiscord, FaGooglePlay, FaInstagram, FaSearch, FaShoppingBag, FaTwitter, FaUserAstronaut } from "react-icons/fa";

//TRANSLATION
import { useTranslation } from 'react-i18next';

function Privacy() {
    const { t, i18n } = useTranslation();
    const [search, setSearch] = useState();

    const handleLangChange = lang => {
        i18n.changeLanguage(lang);
    };

    const handleKeyDown = event => {
        if (event.key === 'Enter') {
            window.location.href = `/search/buds/${search}`
        }
    };

    return (
        <div className="container">
            <header>
                <a href="/players" className="left_entry"><FaUserAstronaut /> {t('home.player')}</a>
                <a href="/merchants" className="left_entry"><FaShoppingBag /> {t('home.merchants')}</a>
                <div className="search">
                    <div className="search_icon"><FaSearch /></div>
                    <input type="text" placeholder={t('home.search')}
                        onChange={event => setSearch(event.target.value)}
                        onKeyDown={handleKeyDown} />
                </div>
                <img src={LOYALBUDS} className="logo" alt="logo LoyalBuds" />
                <a href="https://discord.com/invite/sHbvCwhPGz" target="_blank" rel="noreferrer" className="right_entry social"><FaDiscord /></a>
                <a href="https://twitter.com/LoyalBuds" target="_blank" rel="noreferrer" className="right_entry social"><FaTwitter /></a>
                <a href="https://www.instagram.com/loyalbudsgame/" target="_blank" rel="noreferrer" className="right_entry social"><FaInstagram /></a>
                <span className="right_entry mobile_entry" onClick={() => window.location.href = "/merchants"}><FaShoppingBag /></span>
                <span className="right_entry mobile_entry active" onClick={() => window.location.href = "/players"}><FaUserAstronaut /></span>
            </header>
            <div className="content simple">
                <h1 className="title">
                    {t('privacy.policy')}
                </h1>
                <p>
                    <big className="highlight">
                        {t('privacy.date')}
                    </big>
                </p>
                <p className="justify mb">
                    {t('privacy.txt_01')}
                </p>
                <h2 className="subtitle left">{t('privacy.title_01')}</h2>
                <p className="justify mb">
                    {t('privacy.txt_02')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_03')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_04')}
                </p>
                <h2 className="subtitle left">{t('privacy.title_02')}</h2>
                <p className="justify mb">
                    {t('privacy.txt_05')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_06')} <a href="mailTo:privacy@loyalbuds.io" rel="noreferrer" target="_blank">privacy@loyalbuds.io</a>
                </p>
                <p className="justify mb">
                    {t('privacy.txt_07')}
                </p>
                <h2 className="subtitle left">{t('privacy.title_03')}</h2>
                <p className="justify mb">
                    {t('privacy.txt_08')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_09')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_10')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_11')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_12')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_13')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_14')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_15')}
                </p>
                <h2 className="subtitle left">{t('privacy.title_04')}</h2>
                <p className="justify mb">
                    {t('privacy.txt_16')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_17')}
                </p>
                <h2 className="subtitle left">{t('privacy.title_05')}</h2>
                <p className="justify mb">
                    {t('privacy.txt_17')}
                </p>
                <h2 className="subtitle left">{t('privacy.title_06')}</h2>
                <p className="justify mb">
                    {t('privacy.txt_18')} <a href="mailTo:alert-security@codinsight.com" rel="noreferrer" target="_blank">alert-security@codinsight.com</a>
                </p>
                <p className="justify mb">
                    {t('privacy.txt_19')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_20')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_21')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_22')}
                </p>
                <h2 className="subtitle left">{t('privacy.title_07')}</h2>
                <p className="justify mb">
                    {t('privacy.txt_23')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_24')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_25')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_26')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_27')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_28')}
                </p>
                <h2 className="subtitle left">{t('privacy.title_08')}</h2>
                <p className="justify mb">
                    {t('privacy.txt_29')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_30')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_31')} <a href="mailTo:privacy@loyalbuds.io" rel="noreferrer" target="_blank">privacy@loyalbuds.io</a>
                </p>
                <p className="justify mb">
                    {t('privacy.txt_32')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_33')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_34')}
                </p>
                <h2 className="subtitle left">{t('privacy.title_09')}</h2>
                <p className="justify mb">
                    {t('privacy.txt_35')}
                </p>
                <p className="justify mb">
                    {t('privacy.txt_36')}
                </p>
            </div>
            <footer>
                <img src={LOYALBUDS} className="logo" alt="logo LoyalBuds" />
                <p className="privacy">
                    <a href="/privacy">{t('privacy.policy')}</a> | <a href="/cgu">{t('cgu.general_terms')}</a>
                </p>
                <p className="copyright">
                    {t('home.website')}
                </p>
                <div className="entry">
                    <p>
                        <strong>{t('home.editor_title')}</strong>
                    </p>
                    <p>
                        {t('home.editor_blurb')}
                    </p>
                    <p>
                        N° TVA : FR18907943088
                        <br />
                        Email : contact@codinsight.com
                        <br />
                        {t('home.director_publishing')}
                    </p>
                </div>
                <div className="entry">
                    <p>
                        <strong>{t('home.hosting')}</strong>
                    </p>
                    <p>
                        {t('home.hosting_details')}
                    </p>
                    <p>
                        Amazon Web Services Inc.
                        <br />
                        410 Terry Avenue North,
                        <br />
                        Seattle, WA 98109-5210, USA
                    </p>
                </div>
                <div className="entry">
                    <div className="link" onClick={() => window.open("https://ios.loyalbuds.app")}>
                        <FaAppStore />
                    </div>
                    <div className="link" onClick={() => window.open("https://play.loyalbuds.app")}>
                        <FaGooglePlay />
                    </div>
                    <div className="link" onClick={() => window.open("https://discord.com/invite/sHbvCwhPGz")}>
                        <FaDiscord />
                    </div>
                    <div className="link" onClick={() => window.open("https://twitter.com/LoyalBuds")}>
                        <FaTwitter />
                    </div>
                    <div className="link" onClick={() => window.open("https://www.instagram.com/loyalbudsgame/")}>
                        <FaInstagram />
                    </div>
                    <br />
                    {i18n.language === "en" || i18n.language === "en-US" ? <div className="link" onClick={() => handleLangChange('fr')} style={{ fontSize: "14px", marginTop: "-10px" }}>
                        <span>Version FR</span>
                    </div>
                        :
                        <div className="link" onClick={() => handleLangChange('en')} style={{ fontSize: "14px", marginTop: "-10px" }}>
                            <span>Version EN</span>
                        </div>}
                </div>
            </footer>
        </div>
    );
}

export default Privacy;
